import { TRouterLink } from "@/models/router";
import { RouteConfig } from "vue-router";
import { REmployerCompanyDocuments } from "./views/Documents/REmployerCompanyDocuments";
import { REmployerCompanySummary } from "./views/Summary/REmployerCompanySummary";
import { REmployerCompanySponsorLicence } from "@/pages/Layout/views/Employer/views/Company/views/SponsorLicence/REmployerCompanySponsorLicence";
import { REmployerCompanyDataHistory } from "@/pages/Layout/views/Employer/views/Company/views/DataHistory/REmployerCompanyDataHistory";

export const REmployerCompany: RouteConfig = {
  path: "company",
  component: () =>
    import(
      /* webpackChunkName: "employer-company" */
      "./VEmployerCompany.vue"
    ),
  meta: {
    title: "Company",
    icon: "business-outline",
    newIcon: "building-community",
  },
  children: [
    {
      path: "",
      redirect: REmployerCompanySummary.path,
    },
    REmployerCompanySummary,
    REmployerCompanySponsorLicence,
    REmployerCompanyDocuments,
    REmployerCompanyDataHistory,
    // R1 fixes
    // REmployerCompanyUsersRoles,
  ],
};

export const REmployerCompanyMember: RouteConfig = {
  path: "company",
  component: () =>
    import(
      /* webpackChunkName: "employer-company" */
      "./VEmployerCompany.vue"
    ),
  meta: {
    title: "Company",
    icon: "business-outline",
  },
  children: [
    {
      path: "",
      redirect: REmployerCompanySummary.path,
    },
    REmployerCompanySummary,
    REmployerCompanySponsorLicence,
    REmployerCompanyDocuments,
    REmployerCompanyDataHistory,
    // R1 fixes
    // REmployerCompanyUsersRoles,
  ],
};

export const employerCompanyLinks = (REmployerCompany.children ?? []).reduce(
  (items, { path, meta }) =>
    meta && meta.label
      ? items.concat({
          path: "/" + REmployerCompany.path + (path ? "/" + path : ""),
          label: meta.label,
          basePath: meta.basePath,
        })
      : items,
  [] as TRouterLink[]
);
